import { render, staticRenderFns } from "./TrademarkHistoryForm.vue?vue&type=template&id=6de01016&"
import script from "./TrademarkHistoryForm.vue?vue&type=script&lang=js&"
export * from "./TrademarkHistoryForm.vue?vue&type=script&lang=js&"
import style0 from "./TrademarkHistoryForm.vue?vue&type=style&index=0&id=6de01016&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports